import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('arrow-filled-circle-icon');
export var ArrowFilledCircleIcon = function ArrowFilledCircleIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: cls.name(className),
    width: "16",
    height: "16",
    viewBox: "0 0 46 46"
  }, React.createElement("path", {
    d: "M23.2,0C10.5,0 0.2,10.3 0.2,23C0.2,35.7 10.5,46 23.2,46C35.9,46 46.2,35.7 46.2,23C46.2,10.3 35.9,0 23.2,0ZM29.55,20.8L20.15,10.8L22.95,7.8L37.25,23L23.05,38.2L20.25,35.2L29.65,25.2L9.15,25.2L9.15,20.9L29.55,20.8Z"
  }));
};